import React from "react";
import AuthenticationButton from "./authentication-button";

const AuthNav = () => (
  <div className="">
    <AuthenticationButton />
  </div>
);

export default AuthNav;